import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { DoctorSpecialityService } from "./doctor-speciality.service";
import { DoctorSpeciality } from "./idoctor-speciality";

@Injectable({
    providedIn: 'root'
})
export class DoctorSpecialityResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _doctorSpecialityService: DoctorSpecialityService) { }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, specialities: DoctorSpeciality[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._doctorSpecialityService.getAllSpeciality(data);
    }
}